/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloLink } from '@apollo/client';
import type { NextLink, Operation } from '@apollo/client';

export const pageIdHandler = (pageStore: any) => (operation: Operation, forward: NextLink) => {
  if (pageStore && pageStore.pageId) {
    operation.setContext(({ headers }: Record<string, any>) => ({
      headers: {
        ...headers,
        'x-page-id': pageStore.pageId,
        'x-hcom-origin-id': pageStore.pageId,
      },
    }));
  }

  return forward(operation);
};
export const pageIdLink = (pageStore: any) => {
  return new ApolloLink(pageIdHandler(pageStore));
};
